import { render, staticRenderFns } from "./UsagePolicies.vue?vue&type=template&id=4a3c5abb&scoped=true"
import script from "./UsagePolicies.vue?vue&type=script&lang=js"
export * from "./UsagePolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3c5abb",
  null
  
)

export default component.exports